import {EnvHelper} from '@/helpers/EnvHelper'
import {TWalletNetwork} from '@/model/wallets/types/WalletNetwork'

export type TNeoXChainConfig = {
  chainId: number
  chainIdHex: string
  chainName: string
  rpcUrls: string[]
  blockExplorerUrls: string[]
  nativeCurrency: {name: string; symbol: string; decimals: number}
}

const CHAIN_NAMES: Record<TWalletNetwork, string> = {
  mainnet: 'Neo X Mainnet',
  testnet: 'Neo X Testnet',
}

export abstract class NeoXChainHelper {
  static chainId(network: TWalletNetwork): number {
    const chainId = Number(EnvHelper.bridgeEnv(network).xChainId)

    if (!Number.isFinite(chainId) || chainId <= 0) {
      throw new Error(
        `Neo X is not configured for ${network}: missing VUE_APP_BRIDGE_X_CHAIN_ID_${network.toUpperCase()}`
      )
    }

    return chainId
  }

  static chainIdHex(network: TWalletNetwork): string {
    return `0x${this.chainId(network).toString(16)}`
  }

  static chainConfig(network: TWalletNetwork): TNeoXChainConfig {
    const env = EnvHelper.bridgeEnv(network)

    return {
      chainId: this.chainId(network),
      chainIdHex: this.chainIdHex(network),
      chainName: CHAIN_NAMES[network],
      rpcUrls: EnvHelper.toUrlList(env.xRpcUrls),
      blockExplorerUrls: EnvHelper.toUrlList(env.xExplorerUrl),
      nativeCurrency: {name: 'GAS', symbol: 'GAS', decimals: 18},
    }
  }

  static parseChainId(raw: unknown): number | null {
    if (typeof raw === 'number') {
      return Number.isFinite(raw) ? raw : null
    }

    if (typeof raw !== 'string') {
      return null
    }

    const value = raw.trim()

    if (!value) {
      return null
    }

    const parsed = value.toLowerCase().startsWith('0x')
      ? Number.parseInt(value, 16)
      : Number.parseInt(value, 10)

    return Number.isFinite(parsed) ? parsed : null
  }
}
